export const templateImages = [
  "data:image/jpeg;base64,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",
  "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4YEux7xFXBh1c76NIVDWml64upSzroVYloA&usqp=CAU",
  "",
];

export const saleTemplates = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale4.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale5.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale6.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale7.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale8.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/template/forsale9.png",
];
export const saleOverlay = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale4.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale5.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale6.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale7.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale8.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-sale/overlay/forsale9.png",
];
export const soldTemplates = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold4.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold5.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold6.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold7.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold8.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/sold/template/sold9.png",
];
export const leaseTemplates = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease4.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease5.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease6.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease7.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease8.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/for-lease/template/forlease9.png",
];
export const leasedTemplates = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased4.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased5.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased6.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased7.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased8.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/leased/template/leased9.png",
];
export const testimonialTemplates = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/testimonials/template/testimonial1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/testimonials/template/testimonial2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/testimonials/template/testimonial3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/testimonials/template/testimonial4.png",
];
export const testimonialOverlays = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/testimonials/overlay/testimonial1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/testimonials/overlay/testimonial2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/testimonials/overlay/testimonial3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/testimonials/overlay/testimonial4.png",
];
export const inspectionTemplates = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/open-for-inspections/template/openhomes1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/open-for-inspections/template/openhomes2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/open-for-inspections/template/openhomes3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/open-for-inspections/template/openhomes4.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/open-for-inspections/template/openhomes5.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/open-for-inspections/template/openhomes6.png",
];
export const auctionTemplates = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/auctions/template/auctions1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/auctions/template/auctions2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/auctions/template/auctions3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/auctions/template/auctions4.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/auctions/template/auctions5.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/auctions/template/auctions6.png",
];
export const agentTemplates = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agent-profile/template/agent-profile1.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agent-profile/template/agent-profile2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agent-profile/template/agent-profile3.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agent-profile/template/agent-profile4.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agent-profile/template/agent-profile5.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agent-profile/template/agent-profile6.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agent-profile/template/agent-profile7.png",
];
export const agentLayout = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agentprofiles/overlays/BuyBuySoldandForSaleTemplate-1-16.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agentprofiles/overlays/Version1-082.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agentprofiles/overlays/Version1-092.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agentprofiles/overlays/Version1-102.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agentprofiles/overlays/Version1-112.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agentprofiles/overlays/Version1-122.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/agentprofiles/overlays/Version1-132.png",
];
export const backgroundImages = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/BuyBuySoldandForSaleTemplate-1-13+2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/BuyBuySoldandForSaleTemplate-1-14+2.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/ForSaleTransparentBBCImage-15.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/Picture-01.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/Picture-02.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/Picture-03.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/Picture-04.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/Picture-07.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/background/Picture-08.png",
];
export const layoutImages = [
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/layout/ForSaleandSoldOverlays-01.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/layout/ForSaleandSoldOverlays-02.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/layout/ForSaleandSoldOverlays-03.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/layout/ForSaleandSoldOverlays-04.png",
  "https://v2-wiseberryonline-com-au.s3.ap-southeast-2.amazonaws.com/marketing-resources/layout/ForSaleandSoldOverlays-05.png",

  // "/media/bg_images/Picture-06.jpeg",
  // "/media/bg_images/Picture-07.jpeg",
  // "/media/bg_images/Picture-08.jpeg",
];
export const stateOptions = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AS", label: "American Samoa" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "DC", label: "District Of Columbia" },
  { value: "FM", label: "Federated States Of Micronesia" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "GU", label: "Guam" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MH", label: "Marshall Islands" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "MP", label: "Northern Mariana Islands" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PW", label: "Palau" },
  { value: "PA", label: "Pennsylvania" },
  { value: "PR", label: "Puerto Rico" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VI", label: "Virgin Islands" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const matchedOptions = [
  {
    id: "1",
    createdAt: "2020-07-19T13:11:19.743Z",
    address: "63315 Vanessa Port",
    suburb: "Gleichnershire",
    post_code: "21385-5041",
    price: "62271845",
    bed: 25,
    washroom: 84,
    garage: 96,
    area: "378.00",
    status: 42,
    team: "Dr.",
  },
  {
    id: "2",
    createdAt: "2020-07-20T05:16:14.472Z",
    address: "2852 Rippin Highway",
    suburb: "New Clemens",
    post_code: "74784-8014",
    price: "17755825",
    bed: 38,
    washroom: 99,
    garage: 62,
    area: "814.00",
    status: 82,
    team: "Ms.",
  },
  {
    id: "3",
    createdAt: "2020-07-20T02:21:27.227Z",
    address: "896 Wisoky Throughway",
    suburb: "Marlenton",
    post_code: "12539",
    price: "55489105",
    bed: 49,
    washroom: 27,
    garage: 72,
    area: "368.00",
    status: 65,
    team: "Dr.",
  },
  {
    id: "4",
    createdAt: "2020-07-20T04:29:07.875Z",
    address: "40195 Sheila Knoll",
    suburb: "Nickolasside",
    post_code: "55192-1857",
    price: "81797882",
    bed: 13,
    washroom: 36,
    garage: 3,
    area: "815.00",
    status: 77,
    team: "Miss",
  },
  {
    id: "5",
    createdAt: "2020-07-20T06:46:26.808Z",
    address: "81585 Crist Via",
    suburb: "Darrionview",
    post_code: "94865-1301",
    price: "71054445",
    bed: 72,
    washroom: 44,
    garage: 83,
    area: "900.00",
    status: 10,
    team: "Dr.",
  },
  {
    id: "6",
    createdAt: "2020-07-19T08:50:45.990Z",
    address: "66591 Kassulke Court",
    suburb: "North Cloydmouth",
    post_code: "16862-5824",
    price: "89595535",
    bed: 66,
    washroom: 44,
    garage: 61,
    area: "904.00",
    status: 14,
    team: "Miss",
  },
  {
    id: "7",
    createdAt: "2020-07-19T09:41:55.823Z",
    address: "620 Ivah Gardens",
    suburb: "North Aurore",
    post_code: "89932",
    price: "63537928",
    bed: 61,
    washroom: 15,
    garage: 39,
    area: "366.00",
    status: 91,
    team: "Miss",
  },
  {
    id: "8",
    createdAt: "2020-07-19T20:39:45.049Z",
    address: "961 Jakubowski Neck",
    suburb: "Lake Cleveland",
    post_code: "82164",
    price: "38106178",
    bed: 63,
    washroom: 26,
    garage: 82,
    area: "503.00",
    status: 63,
    team: "Dr.",
  },
  {
    id: "9",
    createdAt: "2020-07-19T21:29:08.289Z",
    address: "2100 Abbie Shoals",
    suburb: "Georgianaview",
    post_code: "87776",
    price: "98474687",
    bed: 51,
    washroom: 30,
    garage: 19,
    area: "688.00",
    status: 43,
    team: "Mrs.",
  },
  {
    id: "10",
    createdAt: "2020-07-19T18:47:37.984Z",
    address: "675 Lesch Loop",
    suburb: "Doyleview",
    post_code: "14473",
    price: "42890256",
    bed: 18,
    washroom: 75,
    garage: 80,
    area: "896.00",
    status: 24,
    team: "Mrs.",
  },
  {
    id: "11",
    createdAt: "2020-07-19T20:47:56.380Z",
    address: "83613 O'Hara Passage",
    suburb: "Maggioside",
    post_code: "22774",
    price: "89889067",
    bed: 84,
    washroom: 61,
    garage: 23,
    area: "637.00",
    status: 94,
    team: "Dr.",
  },
  {
    id: "12",
    createdAt: "2020-07-20T00:11:28.333Z",
    address: "2268 Ritchie Forge",
    suburb: "Naomiburgh",
    post_code: "41478",
    price: "82658015",
    bed: 0,
    washroom: 53,
    garage: 25,
    area: "525.00",
    status: 72,
    team: "Ms.",
  },
  {
    id: "13",
    createdAt: "2020-07-19T23:29:49.827Z",
    address: "8006 Ryann Roads",
    suburb: "North Damian",
    post_code: "66737-6624",
    price: "75681704",
    bed: 25,
    washroom: 47,
    garage: 23,
    area: "9.00",
    status: 78,
    team: "Ms.",
  },
  {
    id: "14",
    createdAt: "2020-07-19T09:28:24.245Z",
    address: "4585 Constantin Inlet",
    suburb: "North Juvenal",
    post_code: "85282",
    price: "35074282",
    bed: 58,
    washroom: 55,
    garage: 16,
    area: "30.00",
    status: 20,
    team: "Mrs.",
  },
  {
    id: "15",
    createdAt: "2020-07-19T13:26:36.691Z",
    address: "4517 Murphy Light",
    suburb: "Lake Molly",
    post_code: "94622",
    price: "87332357",
    bed: 50,
    washroom: 94,
    garage: 27,
    area: "140.00",
    status: 40,
    team: "Ms.",
  },
  {
    id: "16",
    createdAt: "2020-07-19T07:48:36.691Z",
    address: "3512 Abbott Roads",
    suburb: "North Ursula",
    post_code: "29695-9309",
    price: "81300122",
    bed: 22,
    washroom: 32,
    garage: 26,
    area: "807.00",
    status: 5,
    team: "Dr.",
  },
  {
    id: "17",
    createdAt: "2020-07-19T17:16:13.269Z",
    address: "8019 Hilpert Trail",
    suburb: "New Gunnarport",
    post_code: "57788",
    price: "44267462",
    bed: 34,
    washroom: 100,
    garage: 8,
    area: "308.00",
    status: 7,
    team: "Mr.",
  },
  {
    id: "18",
    createdAt: "2020-07-19T18:51:13.259Z",
    address: "20942 Tess Plains",
    suburb: "Terrytown",
    post_code: "02329",
    price: "37796582",
    bed: 14,
    washroom: 70,
    garage: 25,
    area: "24.00",
    status: 46,
    team: "Miss",
  },
  {
    id: "19",
    createdAt: "2020-07-19T08:43:18.286Z",
    address: "171 Ena View",
    suburb: "Susanhaven",
    post_code: "86240",
    price: "83096866",
    bed: 91,
    washroom: 35,
    garage: 56,
    area: "522.00",
    status: 40,
    team: "Mrs.",
  },
  {
    id: "20",
    createdAt: "2020-07-19T22:49:42.060Z",
    address: "816 Barton Falls",
    suburb: "Reichertburgh",
    post_code: "65389-3209",
    price: "87924334",
    bed: 19,
    washroom: 46,
    garage: 77,
    area: "445.00",
    status: 1,
    team: "Mr.",
  },
  {
    id: "21",
    createdAt: "2020-07-19T16:08:09.682Z",
    address: "1073 Patience Stravenue",
    suburb: "Hansbury",
    post_code: "19838",
    price: "98974743",
    bed: 75,
    washroom: 90,
    garage: 95,
    area: "393.00",
    status: 38,
    team: "Mrs.",
  },
  {
    id: "22",
    createdAt: "2020-07-19T18:10:51.915Z",
    address: "1692 Rickey Mountain",
    suburb: "New Walterview",
    post_code: "67633-5372",
    price: "30303368",
    bed: 83,
    washroom: 8,
    garage: 90,
    area: "295.00",
    status: 36,
    team: "Mr.",
  },
  {
    id: "23",
    createdAt: "2020-07-19T20:11:11.181Z",
    address: "3665 Sydni Stravenue",
    suburb: "South Zachery",
    post_code: "58959",
    price: "84126407",
    bed: 55,
    washroom: 50,
    garage: 46,
    area: "239.00",
    status: 67,
    team: "Mrs.",
  },
  {
    id: "24",
    createdAt: "2020-07-19T17:16:10.916Z",
    address: "10444 Hackett Terrace",
    suburb: "Baumbachland",
    post_code: "66274-5486",
    price: "74648580",
    bed: 64,
    washroom: 47,
    garage: 53,
    area: "429.00",
    status: 13,
    team: "Mrs.",
  },
  {
    id: "25",
    createdAt: "2020-07-19T12:38:13.266Z",
    address: "2030 Spinka Well",
    suburb: "Arnebury",
    post_code: "37278-7839",
    price: "96781439",
    bed: 56,
    washroom: 88,
    garage: 58,
    area: "817.00",
    status: 27,
    team: "Mrs.",
  },
  {
    id: "26",
    createdAt: "2020-07-19T07:46:31.100Z",
    address: "415 Upton Ways",
    suburb: "South Jevon",
    post_code: "22668-7759",
    price: "50551553",
    bed: 29,
    washroom: 82,
    garage: 17,
    area: "205.00",
    status: 37,
    team: "Mr.",
  },
  {
    id: "27",
    createdAt: "2020-07-19T10:04:13.509Z",
    address: "81243 Walsh Road",
    suburb: "Moorefort",
    post_code: "03611",
    price: "70785221",
    bed: 59,
    washroom: 53,
    garage: 80,
    area: "675.00",
    status: 20,
    team: "Mrs.",
  },
  {
    id: "28",
    createdAt: "2020-07-19T20:01:56.123Z",
    address: "441 Lorenz Drive",
    suburb: "Legroshaven",
    post_code: "29884-3693",
    price: "61863556",
    bed: 67,
    washroom: 94,
    garage: 48,
    area: "677.00",
    status: 87,
    team: "Dr.",
  },
  {
    id: "29",
    createdAt: "2020-07-20T01:50:38.751Z",
    address: "430 Mitchell Loaf",
    suburb: "Daretown",
    post_code: "52484",
    price: "38258498",
    bed: 11,
    washroom: 50,
    garage: 88,
    area: "950.00",
    status: 24,
    team: "Ms.",
  },
  {
    id: "30",
    createdAt: "2020-07-20T06:49:04.814Z",
    address: "297 Towne Highway",
    suburb: "Waelchiburgh",
    post_code: "48241",
    price: "22437928",
    bed: 41,
    washroom: 95,
    garage: 26,
    area: "176.00",
    status: 36,
    team: "Mr.",
  },
  {
    id: "31",
    createdAt: "2020-07-19T09:28:52.903Z",
    address: "41441 Leuschke Passage",
    suburb: "West Cesar",
    post_code: "82648",
    price: "03155320",
    bed: 39,
    washroom: 61,
    garage: 1,
    area: "337.00",
    status: 47,
    team: "Miss",
  },
  {
    id: "32",
    createdAt: "2020-07-19T13:07:41.774Z",
    address: "22110 Arnaldo Path",
    suburb: "New Eino",
    post_code: "76781",
    price: "60328513",
    bed: 22,
    washroom: 62,
    garage: 31,
    area: "719.00",
    status: 19,
    team: "Dr.",
  },
  {
    id: "33",
    createdAt: "2020-07-19T20:35:40.330Z",
    address: "16615 Ziemann Lodge",
    suburb: "Kshlerinside",
    post_code: "98114-9974",
    price: "81996031",
    bed: 92,
    washroom: 87,
    garage: 79,
    area: "483.00",
    status: 80,
    team: "Mr.",
  },
  {
    id: "34",
    createdAt: "2020-07-19T12:18:14.796Z",
    address: "1268 Abernathy Valleys",
    suburb: "Port Christellehaven",
    post_code: "69568",
    price: "69383398",
    bed: 28,
    washroom: 91,
    garage: 85,
    area: "722.00",
    status: 66,
    team: "Mr.",
  },
  {
    id: "35",
    createdAt: "2020-07-19T10:54:31.487Z",
    address: "6390 Walter Cliff",
    suburb: "South Hassanmouth",
    post_code: "32812-9026",
    price: "80199273",
    bed: 18,
    washroom: 14,
    garage: 94,
    area: "587.00",
    status: 74,
    team: "Miss",
  },
  {
    id: "36",
    createdAt: "2020-07-19T18:47:53.349Z",
    address: "570 Braun Mall",
    suburb: "Johnnyshire",
    post_code: "88439",
    price: "20942573",
    bed: 59,
    washroom: 5,
    garage: 56,
    area: "710.00",
    status: 12,
    team: "Mr.",
  },
  {
    id: "37",
    createdAt: "2020-07-20T03:44:23.130Z",
    address: "362 Miller Stream",
    suburb: "Kossmouth",
    post_code: "46613-3559",
    price: "81585319",
    bed: 92,
    washroom: 35,
    garage: 53,
    area: "435.00",
    status: 57,
    team: "Dr.",
  },
  {
    id: "38",
    createdAt: "2020-07-19T21:56:40.434Z",
    address: "59300 Lindsay Station",
    suburb: "South Robertaton",
    post_code: "13758-9618",
    price: "19515509",
    bed: 14,
    washroom: 85,
    garage: 32,
    area: "868.00",
    status: 34,
    team: "Mrs.",
  },
  {
    id: "39",
    createdAt: "2020-07-20T03:39:24.794Z",
    address: "32370 Fisher Trail",
    suburb: "Raphaelleland",
    post_code: "90997",
    price: "15058483",
    bed: 72,
    washroom: 6,
    garage: 4,
    area: "319.00",
    status: 40,
    team: "Ms.",
  },
  {
    id: "40",
    createdAt: "2020-07-19T11:46:59.269Z",
    address: "386 Pacocha Union",
    suburb: "Lake Haley",
    post_code: "50274-4260",
    price: "51109580",
    bed: 61,
    washroom: 61,
    garage: 40,
    area: "325.00",
    status: 7,
    team: "Mr.",
  },
  {
    id: "41",
    createdAt: "2020-07-19T12:49:06.532Z",
    address: "1850 Powlowski Loop",
    suburb: "Hilpertburgh",
    post_code: "95510",
    price: "80947699",
    bed: 19,
    washroom: 98,
    garage: 79,
    area: "392.00",
    status: 1,
    team: "Mr.",
  },
  {
    id: "42",
    createdAt: "2020-07-20T07:08:43.517Z",
    address: "406 Padberg Neck",
    suburb: "Lake Jeremie",
    post_code: "66352",
    price: "17124416",
    bed: 3,
    washroom: 60,
    garage: 64,
    area: "668.00",
    status: 36,
    team: "Ms.",
  },
  {
    id: "43",
    createdAt: "2020-07-19T15:20:15.311Z",
    address: "264 Omer Green",
    suburb: "Port Mohamedburgh",
    post_code: "55794-8563",
    price: "26531748",
    bed: 39,
    washroom: 19,
    garage: 33,
    area: "692.00",
    status: 91,
    team: "Ms.",
  },
  {
    id: "44",
    createdAt: "2020-07-19T23:30:21.674Z",
    address: "29080 Alfonso Hill",
    suburb: "Mableton",
    post_code: "31045-8957",
    price: "96502448",
    bed: 38,
    washroom: 37,
    garage: 79,
    area: "65.00",
    status: 89,
    team: "Mr.",
  },
  {
    id: "45",
    createdAt: "2020-07-20T01:08:46.937Z",
    address: "8227 Bogan Parkways",
    suburb: "East Lonville",
    post_code: "84231",
    price: "69264675",
    bed: 66,
    washroom: 41,
    garage: 97,
    area: "204.00",
    status: 98,
    team: "Ms.",
  },
  {
    id: "46",
    createdAt: "2020-07-19T21:30:13.712Z",
    address: "7560 Helmer Valleys",
    suburb: "East Kassandra",
    post_code: "41982-9235",
    price: "15288027",
    bed: 15,
    washroom: 39,
    garage: 23,
    area: "530.00",
    status: 91,
    team: "Miss",
  },
  {
    id: "47",
    createdAt: "2020-07-19T10:19:10.799Z",
    address: "370 Padberg Neck",
    suburb: "Cummerataport",
    post_code: "20425-3961",
    price: "27847066",
    bed: 7,
    washroom: 21,
    garage: 31,
    area: "486.00",
    status: 12,
    team: "Mr.",
  },
  {
    id: "48",
    createdAt: "2020-07-19T21:55:22.300Z",
    address: "981 Hal Turnpike",
    suburb: "Jerdeton",
    post_code: "59800-9021",
    price: "74449285",
    bed: 48,
    washroom: 64,
    garage: 25,
    area: "866.00",
    status: 26,
    team: "Ms.",
  },
  {
    id: "49",
    createdAt: "2020-07-19T16:27:12.799Z",
    address: "308 Alena Flat",
    suburb: "Kunzeland",
    post_code: "67467",
    price: "32133268",
    bed: 87,
    washroom: 38,
    garage: 73,
    area: "594.00",
    status: 40,
    team: "Dr.",
  },
  {
    id: "50",
    createdAt: "2020-07-19T18:03:39.175Z",
    address: "09928 Billy Crossing",
    suburb: "Lake Lexus",
    post_code: "82286",
    price: "94689567",
    bed: 82,
    washroom: 94,
    garage: 18,
    area: "78.00",
    status: 55,
    team: "Mr.",
  },
];

// export const ListingInfo = {
//   details: `The Listing Details tab contains key information about the listing, including notes, contacts, property features, contract details, reports and files.`,

//   timeline: `The Listing Timeline provides an overview of all events that occur on a listing, including appointments, listing events, offers, marketing and tasks. Where additional information is available, click an event to read more`,
//   checklist: `"The Listing Checklist is a set of recurring tasks that need to be actioned on each listing. The automated checklist is set up in advance so that when certain events happen on a listing, the relevant checklist task is triggered. For example, whenever a new listing is created, a recurring task may be to ""complete the listing folder"". When checklist tasks fall due, they will appear on the ""Checklists"" tab of the Dashboard.Additional tasks can also be added to the checklist manually, affecting only this listing.”`,

//   advertising: `The Advertising Schedule is a breakdown of the marketing items that will be used to advertise the property. This tab allows you to set up and keep track of the progress of the property advertising schedule, including how much has been spent and is owing from the seller.`,

//   library: `The Listing Library is where the property photos, videos and marketing text is stored, which will be used when marketing the property to the public.`,
//   uploads: `The Uploads tab allows you to preview and upload the listing to property portals such as realestate.com.au and Domain.`,
//   mail: `The Mail Log is a record of correspondence that has been sent to or from the sellers. Emails, letters and SMS messages that are generated by the system are automatically added to the log. Correspondence that was sent outside of the system can be manually added to the log using the "Add" button.`,

//   seller: `The Seller Report is a report that can be sent to the seller weekly, or on the preferred basis. The report can be emailed directly, or downloaded and sent externally.`,

//   posts: `"The Posts tab includes posts that have been created by the seller in the Wiseberry Sellers app, and posts made by members of the office that have been tagged with the listing address. From this tab, existing posts can be managed, and new posts can be created. When a new post is created from this page, it will automatically be tagged with the listing.Posts can also be created on the ""News"" tab in Wiseberry Online.”`,
//   matched_buyers: `The Matched Buyers tab shows the buyers with preferences suited to the listing. By default, buyers will be matched on price, location, property types and features. For advanced matching, use the ""Filter"" button.Click any buyer's name to open them.The ""Status"" column identifies whether an email or SMS has already been sent to them about the listing, if they have a past or future appointment for the listing, and if they have unsubscribed from receiving emails in general.The ""Team"" column contains the initials of the team member who the buyer is currently allocated to.The ""Last Contact"" column contains the date the buyer was last contacted. If the last contact was an appointment, an ""A"" will appear alongside this date.”`,
//   buyer_enuiries: `"The Buyer Enquiries tab shows the buyers who have enquired about the listing.Enquiries are sourced from the Enquiry Log on the Dashboard.Use the ""Filter"" button to filter enquiries.The ""Status"" column identifies whether an email or SMS has already been sent to them about the listing, if they have a past or future appointment for the listing, and if they have unsubscribed from receiving emails in general.The ""Team"" column contains the initials of the team member who the buyer is currently allocated to.The ""Last Contact"" column contains the date the buyer was last contacted. If the last contact was an appointment, an ""A"" will appear alongside this date.”`,
//   viewed_buyers: `"The Viewed Buyers tab shows a history of buyers who have viewed the listing.Use the ""Filter"" button to filter buyers.The ""Type"" column identifies the type of appointment (Open Home, Buyer Appointment or Virtual Buyer Appointment).The ""Status"" column identifies whether an email or SMS has already been sent to them about the listing, if they have a past or future appointment for the listing, if they have made an offer on the listing, and if they have unsubscribed from receiving emails in general.The ""Team"" column contains the initials of the team member who the buyer is currently allocated to. The ""Last Contact"" column contains the date the buyer was last contacted. If the last contact was an appointment, an ""A"" will appear alongside this date.”`,
//   sales_advice: `After an offer has been accepted on a property, the Sales Advice tab contains all the details of the sale.`,
// };
export const ListingTab = [
  "-form",
  "-timeline",
  "-checklist",
  "-advertising",
  "-library",
  "-upload",
  "-maillog",
  "-report",
  "-post",
  "-matched",
  "-enquiries",
  "-viewed",
  "-salesAdvice",
];

export const tabInfo = {
  Diary: `The Wiseberry Online Diary is a calendar with your appointments and tasks.`,
  Dashboard: `The Wiseberry Online Dashboard is a customisable hub of your daily tasks and reminders.`,
  Contacts: `This page is the home of all contacts that appear throughout the system`,
  News: `The Wiseberry Online News page is your daily stop for the latest news and results within the Wiseberry network. To congratulate or reach out to someone for their appearance the News page, simply click their name to view their contact details. •  Today's Birthdays: Members of the Wiseberry network with a birthday today. •  Today's Anniversaries: Members of the Wiseberry network who have reached a yearly milestone in their employment at Wiseberry. •  Office Points Game: The top 10 members of your office who have achieved the most points in your monthly Points Game. •  Top Ratios: The top 5 members of the network with the highest all-time Prospecting, Listing and Buyer ratios. •  The Wiseberry Network's Results: A graph showing the number of Listings and Sales the network has achieved as a whole over the past 12 months. Using the 'Network' drop down, you can view the same for your individual office. •  Top 10 Offices: The top 10 offices who achieved the highest results in the current month, for Listings, Sales and Bonus from Unconditional Sales. •  Top 10 Leaders: The 10 leaders who have received the highest year-to-date points from Leadership Pairing. At the beginning of each month, each Wiseberry leader pairs up with another leader, giving them the opportunity to help and learn from each other. At the end of the month, each leader rates their partner, counting towards their overall ranking. •  Top 20 Performers: The top 20 members of the network who have achieved the highest results in the current month. Points are allocated for each Listing Sold (LS), Listing (L), Sale (S) and Finance Referral (F) result. •  Posts: A feed of posts created by the Wiseberry network, where new posts can be created and the love can be shared by 'liking' posts.`,
  Bulk_filters: `Bulk Filters allows you to generate a list of contacts based on a criteria set by you.`,
  Accounts: `This page contains all invoices that have been generated for your office, as well as your Monthly Settlement Report.  The Monthly Settlement Report is submitted to Head Office within the first 7 days of each month, and includes the listings that settled in the previous month, from which the royalty amount will be calculated. This report also includes any revenue, excluding GST, received in conjunction or ahead of settlement within the same period.`,
  Buyers: `The Buyers Search page contains the contacts who are actively or not actively looking to purchase a property.`,
  Tenants: `The Tenants Search page contains the contacts who are actively or not actively looking to rent a property.`,
  Listings: `The Listing Search page is the home of all listings. Opening to current listings by default, use the Filter menu to find a listing you are looking for. Click any address to open the listing.`,
  Rentals: `The Rental Search page is the home of all rental properties. Opening to available rentals by default, use the Filter menu to find a property you are looking for. Click any address to open the rental.`,
};

export const tabInfoFormName = {
  Prospects: {
    zonesFilterFormSales: `The Sales Zone Analysis tab allows prospecting for sales purposes to be divided into particular areas, and keeps track of activity and market share within those areas. Data is calculated daily at 1:00 AM. Please note that the current data may not be up to date. To view the latest information, kindly access the individual zone where the most recent data is available. Prospects contacted today will be reflected in this table after 1:00 AM.`,
    zonesFilterFormRentals: ``,
    addressManagement: `This page is used to add and manage the addresses that are used by the Prospects module and throughout the system.`,
    prospectFilterForm: `The Prospect Search page is the home of all potential business. Arranged by address, this module holds the details of potential listings and rentals, providing the required tools to attract new business.`,
  },
  System_boards: {
    Cookings: `The Cookings board contains sales that are "cooking", that is, negotiations are being made between the buyer and seller until a sale price is agreed.  A listing will appear on this board after an offer has been made by a buyer through the buyer window, or using the "Add Offer" button.  Counter-offers can be made by sellers and buyers by updating the offer in red.  When the seller and buyer have reached the same price, the handshake icon can be used to generate a sales advice`,
    Individual_Stats: `The Individual Stats board provides insights into how an indivdual is performing in a given time period.`,
    Points_Game: `The Points Game board is a friendly competition between team members on who can achieve the highest number of points.  The leader allocates a number of points to each different type of result, visible in the top "Points" row.  As each team member achieves a result, they receive points, changing their ranking on the board.`,
    Buyers: `The Buyers board provides an overview of who your buyers are and what they are looking for, including the top types, price ranges and locations.`,
    Unsubscribes: `The Unsubscribes board tracks contacts who have unsubscribed from receiving emails or SMS messages. If a contact has requested to be removed from this list, and has given you permission to send them future messages, they can be resubscribed using the "Resubscribe" button.   The Bounces board tracks contacts with an email address or mobile number that a message could not be successfully sent to. You should reach out to contacts on this list to confirm their correct email address or mobile number, and correct it using System Boards the "Update" button.`,
    Leverage: `The Leverage board allows you to refer salespeople (SP) or offices (O) to the Wiseberry network, and get rewarded when they meet quarterly requirements.  When a new referral is entered, it is sent to Head Office for approval, and will remain in the "Pending Referrals" table until approved.  After a referral has been approved, you can keep track of its performance in the "Quarterly Entitlements" table. When all three months are green, the Q (Qualified) column will become green, and your entitlement will be shown in the "Amount" column.`,
    Employee_Notes: `The Employee Notes board contains private notes about team members, viewable only by the logged in user. In order to access this tab, you need to enter the code that is sent to you via SMS, confirming your identity.`,
    Sales_Meeting: `The Sales Meeting board contains the information that should be covered at regular team meetings.`,
    one_on_one: `The 1 on 1 Meeting board contains the information that should be covered at meetings with individual team members.`,
    L_M_meeting: `The L-M Meeting board contains the information that should be covered at management meetings.`,
    Listings: `The Listings board contains: •  Pending Listings: Properties that have had listing appointments, where the outcome wasn't listed. •  Listing Results: Properties that were successfully listed. •  Withdrawn Listings: Listings that have been withdrawn from sale.`,
    Sales: `The Sales board contains: •  Pending Sales: Sales that have been agreed but have not yet gone unconditional. •  Sale Results: Sales that have gone unconditional.`,
    Settlements: `The Settlements board contains: •  Pending Settlements: Sales that have gone unconditional but have not yet settled. •  Settlement Results: Sales that have settled.`,
    Market: `The Market Reviews board contains: •  Required Market Reviews: Listings where a Market Review is required, based on the office settings. •  Market Review Results: Listings where a price change has taken place.`,
    Rentals: `The Rentals board contains: •  Pending Rentals: Properties that have had rental appointments, where a new rental wasn't created as an outcome. •  Rental Results: New rentals that were successfully secured. •  Rented Rentals: Properties that have been rented, and are no longer available for rent. •  Withdrawn Rentals: Rentals that have been withdrawn.`,
    Benchy: `The Benchy's Board allows team members to keep track of the listing appointments they have booked for another salesperson, and the outcome of the appointment.`,
    Finance: `The Finance Referral board allows you to keep track of the contacts referred for finance to Wiseberry's partnered lending specialist, My Local Broker.  New referrals can also be added using the "Add Referral" button.`,
    Sources: `This board provides an overview of the source of listings, sales, new rentals and rented properties. This information is retrieved from the Enquiry Log on the Dashboard.`,
  },
  SingleListing: {
    details: `The Listing Details tab contains key information about the listing, including notes, contacts, property features, contract details, reports and files.`,

    timeline: `The Listing Timeline provides an overview of all events that occur on a listing, including appointments, listing events, offers, marketing and tasks. Where additional information is available, click an event to read more`,
    checklist: `"The Listing Checklist is a set of recurring tasks that need to be actioned on each listing. The automated checklist is set up in advance so that when certain events happen on a listing, the relevant checklist task is triggered. For example, whenever a new listing is created, a recurring task may be to ""complete the listing folder"". When checklist tasks fall due, they will appear on the ""Checklists"" tab of the Dashboard.Additional tasks can also be added to the checklist manually, affecting only this listing.”`,

    advertising: `The Advertising Schedule is a breakdown of the marketing items that will be used to advertise the property. This tab allows you to set up and keep track of the progress of the property advertising schedule, including how much has been spent and is owing from the seller.`,

    library: `The Listing Library is where the property photos, videos and marketing text is stored, which will be used when marketing the property to the public.`,
    uploads: `The Uploads tab allows you to preview and upload the listing to property portals such as realestate.com.au and Domain.`,
    mail: `The Mail Log is a record of correspondence that has been sent to or from the sellers. Emails, letters and SMS messages that are generated by the system are automatically added to the log. Correspondence that was sent outside of the system can be manually added to the log using the "Add" button.`,

    seller: `The Seller Report is a report that can be sent to the seller weekly, or on the preferred basis. The report can be emailed directly, or downloaded and sent externally.`,

    posts: `"The Posts tab includes posts that have been created by the seller in the Wiseberry Sellers app, and posts made by members of the office that have been tagged with the listing address. From this tab, existing posts can be managed, and new posts can be created. When a new post is created from this page, it will automatically be tagged with the listing.Posts can also be created on the ""News"" tab in Wiseberry Online.”`,
    matched_buyers: `The Matched Buyers tab shows the buyers with preferences suited to the listing. By default, buyers will be matched on price, location, property types and features. For advanced matching, use the ""Filter"" button.Click any buyer's name to open them.The ""Status"" column identifies whether an email or SMS has already been sent to them about the listing, if they have a past or future appointment for the listing, and if they have unsubscribed from receiving emails in general.The ""Team"" column contains the initials of the team member who the buyer is currently allocated to.The ""Last Contact"" column contains the date the buyer was last contacted. If the last contact was an appointment, an ""A"" will appear alongside this date.”`,
    buyer_enuiries: `"The Buyer Enquiries tab shows the buyers who have enquired about the listing.Enquiries are sourced from the Enquiry Log on the Dashboard.Use the ""Filter"" button to filter enquiries.The ""Status"" column identifies whether an email or SMS has already been sent to them about the listing, if they have a past or future appointment for the listing, and if they have unsubscribed from receiving emails in general.The ""Team"" column contains the initials of the team member who the buyer is currently allocated to.The ""Last Contact"" column contains the date the buyer was last contacted. If the last contact was an appointment, an ""A"" will appear alongside this date.”`,
    viewed_buyers: `"The Viewed Buyers tab shows a history of buyers who have viewed the listing.Use the ""Filter"" button to filter buyers.The ""Type"" column identifies the type of appointment (Open Home, Buyer Appointment or Virtual Buyer Appointment).The ""Status"" column identifies whether an email or SMS has already been sent to them about the listing, if they have a past or future appointment for the listing, if they have made an offer on the listing, and if they have unsubscribed from receiving emails in general.The ""Team"" column contains the initials of the team member who the buyer is currently allocated to. The ""Last Contact"" column contains the date the buyer was last contacted. If the last contact was an appointment, an ""A"" will appear alongside this date.”`,
    sales_advice: `After an offer has been accepted on a property, the Sales Advice tab contains all the details of the sale.`,
  },
  SingleRental: {
    details: `The Rental Details tab contains key information about the listing, including notes, contacts, property features, contract details, reports and files.`,

    timeline: `The Rental Timeline provides an overview of all events that occur on a listing, including appointments, listing events, offers, marketing and tasks. Where additional information is available, click an event to read more`,
    checklist: `"The Rental Checklist is a set of recurring tasks that need to be actioned on each listing. The automated checklist is set up in advance so that when certain events happen on a listing, the relevant checklist task is triggered. For example, whenever a new listing is created, a recurring task may be to ""complete the listing folder"". When checklist tasks fall due, they will appear on the ""Checklists"" tab of the Dashboard.Additional tasks can also be added to the checklist manually, affecting only this listing.”`,

    library: `The Rental Library is where the property photos, videos and marketing text is stored, which will be used when marketing the property to the public.`,
    uploads: `The Uploads tab allows you to preview and upload the Rental to property portals such as realestate.com.au and Domain.`,
    mail: `The Mail Log is a record of correspondence that has been sent to or from the sellers. Emails, letters and SMS messages that are generated by the system are automatically added to the log. Correspondence that was sent outside of the system can be manually added to the log using the "Add" button.`,

    matched_tenants: `The Matched Tenants tab shows the potential tenants with preferences suited to the rental. By default, tenants will be matched on price, location, property types and features. For advanced matching, use the "Filter" button.  Click any tenant's name to open them.  The "Status" column identifies whether an email or SMS has already been sent to them about the rental, if they have a past or future appointment for the rental, and if they have unsubscribed from receiving emails in general.  The "Last Contact" column contains the date the tenant was last contacted. If the last contact was an appointment, an "A" will appear alongside this date`,
    tenants_enuiries: `The Tenant Enquiries tab shows the tenants who have enquired about the rental.  Enquiries are sourced from the Enquiry Log on the Dashboard.  Use the "Filter" button to filter enquiries.`,
    viewed_tenants: `The Viewed Tenants tab shows a history of tenants who have viewed the rental.  Use the "Filter" button to filter tenants.  The "Type" column identifies the type of appointment (Rental Open Home, Tenant Appointment or Virtual Tenant Appointment).  The "Status" column identifies whether an email or SMS has already been sent to them about the rental, if they have a past or future appointment for the rental, and if they have unsubscribed from receiving emails in general.  The "Last Contact" column contains the date the tenant was last contacted. If the last contact was an appointment, an "A" will appear alongside this date.`,
  },
  Settings: {
    office_details: `This page contains your agency details.`,
    apm: `APM Pricefinder (https://www.pricefinder.com.au/) is used throughout Wiseberry Online to retrieve contact details, comparable sale information and more.  To make use of these features, the office APM Pricefinder account needs to be connected on this page.  •  Username and Password: The login for your office APM Pricefinder account. • Default Radius: The default radius, in kilometres, used by the system when searching for comparable sold properties. • Default Sale History Time Range: The default time range, in months, used by the system when searching for comparable sold properties`,
    uploads: `In Wiseberry Online, properties can be uploaded directly to third-party portals, such as realestate.com.au and Domain.  To connect to a property portal, simply enter your Agency ID into the corresponding field.  Your Agency ID is a collection of characters that the portal uses to identify your office, for example: WB1234. This ID will be provided to you when setting up an account with each preferred portal, and/or can be retrieved by contacting the relevant portal.`,
    role_management: `Role Management allows you to manage access to different parts of Wiseberry Online, as well as the actions that can be taken within those areas.  The roles you set up in Role Management can then be attached to users in User Management.`,
    bonus_management: `Bonus Structure allows you to set the way bonus is to be calculated, and the conditions that apply. These structures can later be attached to users in User Management.`,
    user_management: `User Management allows you to manage the users that have access to your office in Wiseberry Online.`,
    mini_teams: `Mini Teams allows you to set up groups of users who will share access to each other throughout the system. This allows smaller groups of staff to work together within the same office.  In any "Team" drop downs that appear throughout the system, members of that mini team will see an additional option that is their mini team name.  For example, if John is a member of "Team Blue" and opens the Diary, using the "Team" drop down, he is able to switch to "Team Blue" and see appointments for all members in his mini team.  By the same token, the mini team's combined results will be visible to team leaders in the System Boards by switching to the mini team name using the "Team" drop down.  Members of the same mini team also share Tasks on the Dashboard, for example Buyers to Call. If the Task is completed by one mini team member, it is marked as complete on all Dashboards within the same mini team.`,
    branding: `This page allows you to set the appearance of emails and letters that are generated by the system.`,
    advertising: `This page allows you to create advertising packages that can be offered to potential sellers during listing presentations.`,
    lisintg_presentation: `This page allows you to customise items that will appear in the listing presentation, for all members of the office.`,
    buyers_sellers: `This page allows you to add recommended services that can be shown to buyers and/or sellers in the Wiseberry Buyers and Sellers apps.  Using the Display Settings, you can also decide whether office sales are included in the office news feed in the Wiseberry Buyers and Sellers apps.`,
    notifications: `Each Wiseberry Online user has their own Notification Settings page, from where they can enable and disable the various types of notifications, and select how they want to receive them.  This page allows you to select which notifications are mandatory, in that, individual users cannot turn them off.  For example, if you do not wish to allow members of your office to turn off "Listing Feedback is due" notifications via email, you would tick the "Email" column alongside this notification.`,
    cloud_storage: `Throughout the system, there are many places where items can be uploaded and stored in the Cloud. Using this page, you can keep track of your Cloud Storage usage, and manage all items that have been uploaded.`,
    recently_deleted: `When Contacts, Buyers, Prospects, Prospect Addresses or Users are deleted in Wiseberry Online, they are stored in the Recently Deleted table for 90 days, allowing them to be restored.`,
  },
};
